import React, {Fragment} from 'react'
import {Route, Switch, Redirect, useRouteMatch, Link} from 'react-router-dom'
import Accounts from 'admin/components/Accounts'
import Flash from 'admin/components/shared/Flash'
import Tabs from 'admin/components/shared/Tabs'
import Alerts from '../Alerts'

export default () => {
  const match = useRouteMatch()
  const {organisationID} = match.params

  return (
    <Fragment>
      <Flash />
      <Alerts section={true} types={['overdue', 'suspension']} />
      <Tabs
        collection={[
          {label: 'Draft', to: `/orgs/${organisationID}/accounts/draft`},
          {label: 'Active', to: `/orgs/${organisationID}/accounts/active`},
          {label: 'Archived', to: `/orgs/${organisationID}/accounts/archived`}
        ]}
      />
      <Switch>
        <Redirect exact path={match.path} to={`/orgs/${organisationID}/accounts/active`} />
        <Route path={`${match.path}/:state`} component={Accounts} />
      </Switch>
    </Fragment>
  )
}
